import { render } from "./GroupSwitch.vue?vue&type=template&id=1efad465&scoped=true"
import script from "./GroupSwitch.vue?vue&type=script&lang=js"
export * from "./GroupSwitch.vue?vue&type=script&lang=js"

import "./GroupSwitch.vue?vue&type=style&index=0&id=1efad465&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efad465"]])

export default __exports__